import type { DeviceViewEdgeEntity } from '../deviceViewTypes';

export const isWlcApEdge = (deviceViewEntity: DeviceViewEdgeEntity): boolean =>
  deviceViewEntity.sourceType === 'wlc' && deviceViewEntity.targetType === 'ap';
